/* eslint-disable no-console */
import { Wrap } from './styles';

import LayerList from './components/LayerList';

import Icon from '@map/components/Icons';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import { useState, useEffect } from 'react';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';

/**
 * MenuLayers
 * 
 * @param {object} appContext
 * @param {*} props
 * 
 * @returns 
 */
export const MenuLayers = ({ appContext, ...props }) => {
  const { layers } = useMap();

  const [currentScroll, setCurrentScroll] = useState(0);  
  const [scrolled, setScrolled] = useState(false);

  /**
   * Observa se houve scrolling
   */
  useEffect(() => {
    if (scrolled) {      
      setScrolled(false)      
    }  
  }, [scrolled]);

  const handleScroll = (e) => {
    let element = e.target;    
    if (element.scrollTop !== currentScroll) {
      setCurrentScroll(element.scrollTop);
      setScrolled(true);
    }
  };

  return (
    <Wrap countLayers={layers ? layers.length : 0}>
      <header>
        <Icon i="map-layersmenu-layer" />
        <h1>CAMADAS</h1>
        <button
          className="addlayer-mobile"
          onClick={() =>
            appContext.genericSetContextProp('layersCatalogIsOpened', true)
          }
        >
          <Icon i="map-layersmenu-plus" />
        </button>
      </header>
      <div
        className="layers-container"
        // setScrolled={setScrolled}
        onScroll={handleScroll}
      >
        <LayerList appContext={appContext} scrolled={scrolled}/>
      </div>
    </Wrap>
  );
};

MenuLayers.properties = {
  id: 'CPN-MP-MENU_LAYERS',
  alias: 'Menu de camadas',
  description: '...',
  configurable: true,
};

export default MenuLayers;
